import PptxGenJS from "pptxgenjs";
import dayjs from "dayjs";

export const addEndSlide = (pres: PptxGenJS) => {
  pres.addSlide({ masterName: "LOGO_CENTER_MASTER" });
};
